var React = require('react')
var createReactTimeout = require('./reactTimeout.js')

module.exports = createReactTimeout(React)



//////////////////
// WEBPACK FOOTER
// ./~/react-timeout/src/web.js
// module id = 77
// module chunks = 0